import React, { FC, MouseEvent, useCallback } from "react";

export interface ExternalLinkProps {
    readonly url: string;
    readonly className?: string;
}

function getSvg() {
    return (
        <svg viewBox="0 0 20 20">
            <path d="M17 17H3V3h5V1H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5h-2z" />
            <path d="M19 1h-8l3.29 3.29-5.73 5.73 1.42 1.42 5.73-5.73L19 9V1z" />
        </svg>
    );
}

const ExternalLink: FC<ExternalLinkProps> = props => {
    const { url } = props;

    const handleClick = useCallback((ev: MouseEvent) => {
        ev.preventDefault();
    }, []);

    return (
        <a href={url} aria-label="read more" target="_blank" rel="noreferrer" className={props.className} onClick={handleClick}>{getSvg()}</a>
    );
};

export default ExternalLink;
